import React, { useState, Dispatch, SetStateAction } from 'react';
import { Student } from 'coaching/containers/GetProspectiveStudentOptionsContainer';

import Radio, { RadioColor } from 'components/Radio';
import Row from 'components/Row';
import Label from 'components/Label';

export type Props = {
  students: Student[];
  selectedStudentUuid: string;
  onSelectStudent: (studentUuid: string) => void;
  selectedChildName: string;
  onSelectChildName: (selectedChildName: string) => void;
  renderChildNameFormElement: (
    selectedChildName: string,
    setChildSelectedName: (selectedChildName: string) => void
  ) => React.ReactElement;
};

export default function TutoringSelfServeViewStudentDetailsConnected(props: Props) {
  const {
    students,
    onSelectStudent,
    onSelectChildName,
    selectedStudentUuid,
    selectedChildName,
    renderChildNameFormElement,
  } = props;
  const shouldShowAddChild = (!selectedStudentUuid && selectedChildName);
  const [showAddChild, setShowAddChild] = useState<boolean>(!!shouldShowAddChild);
  const renderRadioAddStudent = (
    showAddChild: boolean,
    setShowAddChild: Dispatch<SetStateAction<boolean>>
  ) => {
    return (
      <Radio
        color={RadioColor.koolaid}
        data-test="get-started-add-child-radio"
        label="Add another student"
        name={undefined}
        onChange={() => {
          onSelectStudent('');
          setShowAddChild(true);
        }}
        checked={showAddChild}
      />
    );
  };

  return (
    <Row>
      <Label>Who needs tutoring?</Label>
      {students.map(student => {
        const { name, uuid } = student;
        return (
          <Radio
            color={RadioColor.koolaid}
            data-test={uuid}
            key={uuid}
            label={name}
            name={uuid}
            checked={selectedStudentUuid === uuid}
            onChange={e => {
              onSelectStudent(e.currentTarget.name);
              setShowAddChild(false);
            }}
          />
        );
      })}
      {showAddChild ? (
        <React.Fragment>
          <Row>{renderRadioAddStudent(showAddChild, setShowAddChild)}</Row>
          {renderChildNameFormElement(selectedChildName, onSelectChildName)}
        </React.Fragment>
      ) : (
        renderRadioAddStudent(showAddChild, setShowAddChild)
      )}
    </Row>
  );
}
